import React from 'react';
import ReactDOM from 'react-dom/client';
import { persistStore } from 'redux-persist';
import { Provider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import './index.scss';
import App from './App';
import { store } from './core/app_state_config';
// import reportWebVitals from './reportWebVitals';

let persistor = persistStore(store);
const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <App />
      </PersistGate>
    </Provider>
  </React.StrictMode>
);


// reportWebVitals((perfEntries: any) => {
//   perfEntries.getEntriesByType('navigation').forEach((navigationEntry: any) => {
//     console.log('Navigation Time:', navigationEntry);
//   });
// });
